import { lazy } from 'react';

import { ROUTES } from '@config';

import {
  AuthPageContainer,
  NoAuthPageContainer,
  PageContainer,
} from '../components/other/PageContainers';

const IndexPage = lazy(() => import('../pages/IndexPage'));
const LoginPage = lazy(() => import('../pages/Login/LoginPage'));
const ForgotPasswordPage = lazy(() => import('../pages/ForgotPasswordPage'));
const ResetPasswordPage = lazy(() => import('../pages/ResetPasswordPage'));
const DashboardPage = lazy(() => import('../pages/Dashboard/DashboardPage'));
const AllExecutionsPage = lazy(() => import('../pages/AllExecutionsPage/AllExecutionsPage'));
const FlowsPage = lazy(() => import('../pages/FlowsPage/FlowsPage'));
const FlowBuilderPage = lazy(() => import('../pages/FlowBuilderPage/FlowBuilderPage'));
const FlowDetailPage = lazy(() => import('../pages/FlowDetailPage/FlowDetailPage'));
const ConnectionsPage = lazy(() => import('../pages/ConnectionsPage/ConnectionsPage'));
const ProfilePage = lazy(() => import('../pages/ProfilePage/ProfilePage'));
const AnalyticsPage = lazy(() => import('../pages/AnalyticsPage/AnalyticsPage'));
const BillingPage = lazy(() => import('../pages/BillingPage/BillingPage'));
const SentryErrorPage = lazy(() => import('../pages/SentryErrorPage'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));

export const APP_ROUTES = [
  // Just functions / redirects
  {
    path: ROUTES.INDEX,
    element: <IndexPage />,
  },
  // Need to be logged out
  {
    path: ROUTES.LOGIN,
    element: (
      <NoAuthPageContainer>
        <LoginPage />
      </NoAuthPageContainer>
    ),
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: (
      <NoAuthPageContainer>
        <ForgotPasswordPage />
      </NoAuthPageContainer>
    ),
  },
  // Need to be logged in
  {
    path: ROUTES.FLOWS,
    element: (
      <AuthPageContainer>
        <FlowsPage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.EXECUTIONS,
    element: (
      <AuthPageContainer>
        <DashboardPage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.EXECUTIONS_ALL,
    element: (
      <AuthPageContainer>
        <AllExecutionsPage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.FLOW_BUILDER,
    element: (
      <AuthPageContainer>
        <FlowBuilderPage />
      </AuthPageContainer>
    ),
  },
  {
    path: `${ROUTES.FLOW}/:flow${ROUTES.FLOW_DETAIL}/:flowCall`,
    element: (
      <AuthPageContainer>
        <FlowDetailPage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.CONNECTIONS,
    element: (
      <AuthPageContainer>
        <ConnectionsPage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.PROFILE,
    element: (
      <AuthPageContainer>
        <ProfilePage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.ANALYTICS,
    element: (
      <AuthPageContainer>
        <AnalyticsPage />
      </AuthPageContainer>
    ),
  },
  {
    path: ROUTES.BILLING,
    element: (
      <AuthPageContainer>
        <BillingPage />
      </AuthPageContainer>
    ),
  },
  // Can be both logged in / out
  {
    path: ROUTES.RESET_PASSWORD,
    element: (
      <PageContainer noLayout>
        <ResetPasswordPage />
      </PageContainer>
    ),
  },
  {
    path: ROUTES.SENTRY_ERROR,
    element: (
      <PageContainer noLayout>
        <SentryErrorPage />
      </PageContainer>
    ),
  },
  {
    path: '*',
    element: (
      <PageContainer noLayout>
        <NotFoundPage />
      </PageContainer>
    ),
  },
];
